import React, { useEffect, useState } from 'react'
import { leadsEdit, view, countryList } from "../../../Context/api";
import { leadAddValidation } from '../../../Context/validation';
import axios from "axios";
import { commonMessage, statusCodes } from "../../../Constants/generalConfig";
import Spinner from '../../Spinner/spinner';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from 'formik';
import NumberInput from '../../../Component/PhoneInput/phoneInput';
import { isValidPhoneNumber } from 'react-phone-number-input';
import UseEditLead from './Hooks/useEditLead';

const EditLead = () => {
    // const [countryData, setCountryData] = useState([])
    // const [spinner, setSpinner] = useState(false)
    // const { id } = useParams()

    // const adminData = JSON.parse(localStorage.getItem('adminData'));
    // const navigate = useNavigate()
    // useEffect(() => {
    //     getLead()
    //     countryListData()
    // }, [])

    // const getLead = () => {
    //     axios.post(view(), { leadId: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
    //         if (resp.data.code === statusCodes.ok) {
    //             leadEdit.setValues(resp.data.data[0])
    //         }
    //         else {
    //             toast.error(resp.data.message)
    //         }
    //     })
    //         .catch(() => {
    //             toast.error(commonMessage.networkError)
    //             setSpinner(false)
    //         })
    // }
    // const countryListData = () => {
    //     const data = {
    //         id: adminData.userId,
    //         isDeleted: true,
    //         isActive: true,
    //         searchText: '',
    //         page: 1,
    //         count: 100
    //     }

    //     axios.post(countryList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
    //         if (resp.data.code === statusCodes.ok) {
    //             setCountryData(resp.data.data)

    //         }

    //         else {
    //             setCountryData([])


    //         }
    //     })
    //         .catch(() => {
    //             toast.error(commonMessage.networkError)
    //             setSpinner(false)
    //         })
    // }
    // const leadEdit = useFormik({
    //     initialValues: {
    //         name: '',
    //         email: '',
    //         mobileNo: '',
    //         providerName: '',
    //         description: '',
    //         country: ''
    //     },
    //     validationSchema: leadAddValidation,
    //     validate: (values) => {
    //         const errors = {};
    //         if (values?.mobileNo?.length > 0 && (values?.mobileNo && isValidPhoneNumber(values?.mobileNo))) {
    //             delete errors.mobileNo
    //         } else {
    //             errors.mobileNo = "Please enter a valid mobile number ";
    //         }
    //         return errors;
    //     },
    //     onSubmit: (values) => {
    //         const data = {
    //             name: values.name.trim(),
    //             email: values.email.trim(),
    //             providerName: values.providerName.trim(),
    //             createdbyId: adminData?.userId,
    //             description: values.description.trim(),
    //             mobileNo: values.mobileNo.toString().trim(),
    //             country: values.country,
    //             leadId: id
    //         }
    //         // console.log(data, 'lllll')
    //         axios.post(leadsEdit(), data).then((resp) => {
    //             if (resp.data.code === statusCodes.ok) {
    //                 // leadEdit.resetForm()
    //                 toast.success(resp.data.message)
    //                 setSpinner(false)
    //                 setTimeout(() => {
    //                     navigate(-1)
    //                 }, 1000);
    //             }
    //             else {
    //                 toast.error(resp.data.message)
    //                 setSpinner(false)
    //             }
    //         })
    //             .catch(() => {
    //                 toast.error(commonMessage.networkError)
    //                 setSpinner(false)
    //             })
    //     }
    // })
    const {
        countryData,
        spinner,
        leadEdit
    }=UseEditLead()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Edit Lead
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={leadEdit.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Name *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                onChange={leadEdit.handleChange}
                                value={leadEdit.values.name}
                            />
                            {leadEdit.touched.name && leadEdit.errors.name ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadEdit.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Business Name*</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='providerName'
                                onChange={leadEdit.handleChange}
                                value={leadEdit.values.providerName}

                            />
                            {leadEdit.touched.providerName && leadEdit.errors.providerName ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadEdit.errors.providerName}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Email *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='email'

                                onChange={leadEdit.handleChange}
                                value={leadEdit.values.email}
                            />
                            {leadEdit.touched.email && leadEdit.errors.email ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadEdit.errors.email}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Mobile Number *</label>
                            <NumberInput
                                width={false}
                                Require={false}
                                Name="mobileNo"
                                HandleChange={leadEdit}
                                Value={leadEdit.values.mobileNo}
                            />
                            {leadEdit.touched.mobileNo && leadEdit.errors.mobileNo ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadEdit.errors.mobileNo}
                                </div>
                            ) : null}
                        </div>

                        <div className='col-md-6'>
                            <label htmlFor="recipient-name" className="col-form-label">Country *</label>
                            <select className='form-select' name='country' disabled onChange={leadEdit.handleChange} value={leadEdit.values.country}>
                                <option hidden>Select Country</option>
                                {
                                    countryData?.map((item, index) =>
                                        <option value={item._id}>{item.name}</option>

                                    )}
                            </select>
                            {/* <input type="text" className='form-control' name='country' disabled onChange={leadEdit.handleChange} value={leadEdit.values.country} /> */}
                            {leadEdit.touched.country && leadEdit.errors.country ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadEdit.errors.country}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Description *</label>
                            <textarea className='form-control' cols="30" rows="1" disabled name='description' onChange={leadEdit.handleChange} value={leadEdit.values.description}></textarea>
                            {leadEdit.touched.description && leadEdit.errors.description ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {leadEdit.errors.description}
                                </div>
                            ) : null}
                        </div>
                        <div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default EditLead